const ORGANIZER_CANVASS_KEY = 'organizer_canvass'

/**
 * [Canvass this, CT-9] The ids-only "organizer underneath" marker: an organizer is canvassing under
 * their own grant session. Ids + the campaign label (which the grant mirror already holds) only —
 * never a token, never a name. UX signal only; the server trusts neither this nor the mirror.
 */
export interface OrganizerCanvass {
  grantId: string
  campaignId: string
  campaignLabel: string
}

export function readOrganizerCanvass(): OrganizerCanvass | null {
  try {
    const raw = localStorage.getItem(ORGANIZER_CANVASS_KEY)
    if (!raw) return null
    const { grantId, campaignId, campaignLabel } = JSON.parse(raw) as Record<string, unknown>
    if (typeof grantId !== 'string' || typeof campaignId !== 'string' || typeof campaignLabel !== 'string') return null
    return { grantId, campaignId, campaignLabel }
  } catch {
    return null
  }
}

export function writeOrganizerCanvass(m: OrganizerCanvass): void {
  // Pick explicitly so a wider object (e.g. a GrantIdentity) can never leak a name into localStorage.
  const { grantId, campaignId, campaignLabel } = m
  try {
    localStorage.setItem(ORGANIZER_CANVASS_KEY, JSON.stringify({ grantId, campaignId, campaignLabel }))
  } catch {
    // storage unavailable — the marker is a UX convenience only
  }
}

export function clearOrganizerCanvass(): void {
  try {
    localStorage.removeItem(ORGANIZER_CANVASS_KEY)
  } catch {
    // ignore
  }
}
